import {Form} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

CommentField.propTypes = {
    valid: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    readonly: PropTypes.bool
};

export function CommentField(props) {
    return <Form.Group>
        <Form.Label><strong>Komentarz</strong></Form.Label>
        <Form.Control as="textarea"
                      className={props.valid ? "": "is-invalid"} onChange={props.onChange}
                      name="comment"
                      disabled={props.readonly}
                      value={props.value}
                      type="text"
        />
    </Form.Group>;
}